// Etiquetas en español de valores que llegan CRUDOS de la base de datos (estado y tipo de asamblea).
// Un solo lugar para no repetirlas en cada pantalla. Un valor desconocido (o vacío) se muestra tal cual.
export const ESTADO_ASAMBLEA = { pendiente: 'Pendiente', en_progreso: 'En progreso', finalizada: 'Finalizada' };

export const etiquetaEstado = (estado) => ESTADO_ASAMBLEA[estado] || estado;

// «ordinaria» → «Ordinaria», «extraordinaria» → «Extraordinaria».
export const etiquetaTipo = (tipo) => (tipo ? tipo.charAt(0).toUpperCase() + tipo.slice(1) : tipo);
